import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@/components/Common/Modal';
import { Citation } from '@/services/rag';

interface SourceModalProps {
  citation: Citation | null;
  isOpen: boolean;
  onClose: () => void;
}

export const SourceModal: React.FC<SourceModalProps> = ({ citation, isOpen, onClose }) => {
  const { t } = useTranslation();
  if (!citation) return null;

  return (
    <Modal open={isOpen} onClose={onClose} title={citation.document_name}>
      <div className="space-y-2">
        <p className="text-sm text-muted-foreground">
          {t('chatPage.chunkLabel', { index: citation.chunk_index + 1 })}
        </p>
        <p className="text-sm">{citation.text}</p>
      </div>
    </Modal>
  );
};
